import { createGetWebComponentOptionsHandler } from '@salsita-ai/platform-project-sdk/domain'

import { higginsAttributes } from '../systems/attributes.js'

export const getWebComponentOptionsHandler = createGetWebComponentOptionsHandler(() => ({
  properties: higginsAttributes,
}))
